import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  ClickableTag,
  Divider,
  toggleObject,
} from '@makeably/creativex-design-system';
import styles from './ChartMetricSelection.module.css';

const optionProps = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
});
const optionPropsArray = PropTypes.arrayOf(optionProps);

const propTypes = {
  chartMetrics: optionPropsArray.isRequired,
  label: PropTypes.string.isRequired,
  maxChartMetrics: PropTypes.number,
  nonChartMetrics: optionPropsArray.isRequired,
  onRemoveMetric: PropTypes.func.isRequired,
  setChartMetrics: PropTypes.func.isRequired,
};

const defaultProps = {
  maxChartMetrics: 2,
};

function ChartMetricSelection({
  chartMetrics,
  label: chartMetricLabel,
  maxChartMetrics,
  nonChartMetrics,
  onRemoveMetric,
  setChartMetrics,
}) {
  const renderCheckbox = (metric) => {
    const isChecked = chartMetrics.includes(metric);
    const metricLabel = metric.label.replaceAll('\n', ' ');
    const label = (
      <ClickableTag
        label={metricLabel}
        onRemove={() => onRemoveMetric(metric)}
      />
    );

    const onChange = () => setChartMetrics((prev) => toggleObject(prev, metric));

    return (
      <div key={metric.value} className={styles.checkbox}>
        <Checkbox
          ariaLabel={metricLabel}
          checked={isChecked}
          disabled={chartMetrics.length >= maxChartMetrics && !isChecked}
          label={label}
          onChange={onChange}
        />
      </div>
    );
  };

  return (
    <div className={styles.checkboxes}>
      <div className="t-caption-1">
        { chartMetricLabel }
      </div>
      { chartMetrics.map(renderCheckbox) }
      <Divider />
      { nonChartMetrics.map(renderCheckbox) }
    </div>
  );
}

ChartMetricSelection.propTypes = propTypes;
ChartMetricSelection.defaultProps = defaultProps;

export default ChartMetricSelection;
